function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.248 4.153l-4.568 8.762c-.668.15-1.313.418-1.83.935l-.018.016-.017.02c-.74.843-.988 1.938-1.389 3.092-.372 1.07-.874 2.197-1.736 3.275H2.25v1.5h6.586v-.054c4.045-.138 6.079-1.253 7.32-2.55.912-.913 1.184-2.179.953-3.363L22.48 5.6l-1.327-.7-3.091 5.863L16.08 9.64l2.498-4.793-1.33-.694zm-1.862 6.818l1.976 1.12-1.052 1.995c-.063-.074-.087-.166-.156-.236-.506-.505-1.135-.77-1.786-.926l1.018-1.953zm-1.884 3.276c.574 0 1.148.221 1.59.664a2.239 2.239 0 010 3.182l-.005.006-.006.006c-.962 1.007-2.35 1.845-5.54 2.057.571-.94 1.016-1.87 1.302-2.692.416-1.197.72-2.134 1.09-2.568a2.244 2.244 0 011.569-.655z",
  fill: "#000"
})));